import { InfoCertificatoVO } from "@app/shared/vo/info-certificatoVO";

export class InfoFirmaVO {
  certificateInfos: InfoCertificatoVO[] = new Array<InfoCertificatoVO>();
  level: number;
  signingTime: number;
}
